<template>
  <div style="text-align: center; margin: 0 auto; max-width: 640px">
    <h2>在线注册-代表队</h2>
    <el-form
      :model="teamForm"
      status-icon
      :rules="teamFormRules"
      ref="teamForm"
      label-width="100px"
    >
     <el-form-item label="手机号" prop="mobile">
      <el-input
              placeholder="请输入手机号码"
              v-model="teamForm.mobile"
              maxlength="255"
            >
              <el-button slot="append" :disabled="isSending" @click="sendSms">{{
                smsText
              }}</el-button></el-input
            >
      </el-form-item>
      <el-form-item label="验证码" prop="smsCode">
        <el-row>
          <el-col :span="24"
            ><el-input
              placeholder="请输入验证码"
              v-model="teamForm.smsCode"
              maxlength="255" auto-complete="off"
            ></el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="登录密码" prop="password">
        <el-row>
          <el-col :span="16">
            <el-input
              type="password"
              v-model="teamForm.password"
              maxlength="255" auto-complete="off"
            ></el-input></el-col
          ><el-col :span="8"
            ><span>登录密码最少5位数字母数字</span>
          </el-col></el-row
        >
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmPassword">
        <el-row>
          <el-col :span="16"
            ><el-input
              type="password"
              v-model="teamForm.confirmPassword"
              maxlength="255"
            ></el-input></el-col
          ><el-col :span="8"
            ><span>确认密码最少5位数字母数字</span></el-col
          ></el-row
        >
      </el-form-item>
      <el-form-item label="代表队名称" prop="name">
        <el-row>
          <el-col :span="16"
            ><el-input
              v-model="teamForm.name"
              maxlength="255"
            ></el-input></el-col
        ></el-row>
      </el-form-item>
      <el-form-item label="领队" prop="caption">
        <el-row>
          <el-col :span="16">
            <el-input
              v-model="teamForm.caption"
              maxlength="255"
            ></el-input></el-col
        ></el-row>
      </el-form-item>
      <el-form-item label="教练" prop="coach">
        <el-row>
          <el-col :span="16">
            <el-input
              v-model="teamForm.coach"
              maxlength="255"
            ></el-input></el-col
        ></el-row>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-link href="#/login" type="success" style="margin-right: 20px"
        >已有账号立即登录</el-link
      >
      <el-button type="primary" @click="RegisterTeam" :disabled="isLoading" :loading="isLoading"
        >确 定</el-button
      >
    </div>
  </div>
</template>
<script>
import TeamApi from '../apis/team'
import SMSAPI from "../apis/sms";

export default {
  data () {
    var validatePass3 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.teamForm.password !== '') {
          this.$refs.teamForm.validateField('confirmPassword');
        }
        callback();
      }
    };
    var validatePass4 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.teamForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入登录账号'));
      } 
       if (value.length<4) {
        callback(new Error('登陆账户最少4位数字或字符!'));
      } else {
        callback();
      }
    };
    var validateMobile = (rule, value, callback) => {
      const reg = /^[0-9]{11}$/;
      if (value == "" || value == undefined || value == null) {
        callback();
      } else {
        if (!reg.test(value) && value != "") {
          callback(new Error("请输入正确的手机号码"));
        } else {
          callback();
        }
      }
    };
    let validateCode = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请输入验证码"));
      } else if (value.length != 5) {
        return callback(new Error("输入正确5位验证码"));
      } else {
        return callback();
      }
    };

    return {
      isLoading: false,
       isSending: false,
      timeCounter: 60,
      smsText: "获取验证码",
      teamForm: {
           mobile: null,
        smsCode: null,
        password: null,
        confirmPassword: null,
        name: null,
        caption: null,
        coach: null,
        mobile: null
      },
      teamFormRules: {
       mobile: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: validateMobile, trigger: "blur" },
        ],
        smsCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          {
            validator: validateCode,
            trigger: "blur",
          },
        ],
        password: [{ required: true, message: '请输入登录密码', trigger: 'blur' },
        { validator: validatePass3, trigger: 'blur' }],
        confirmPassword: [{ required: true, message: '请输入确认密码', trigger: 'blur' },
        { validator: validatePass4, trigger: 'blur' }],
        name: [{ required: true, message: '请输入代表队名称', trigger: 'blur' }],
        mobile: [{ required: true, message: '请输入手机号码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    RegisterTeam () {
      this.isLoading = true
      this.$refs.teamForm.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.teamForm)
          TeamApi.register(params).then(result => {
            if (result.code == 0) {
              this.$message.success({ showClose: true, message: '注册成功', duration: 2000 });
              this.$refs['teamForm'].resetFields();             
              this.isLoading = false
               this.$alert('代表队账户注册成功', '提示', {confirmButtonText: '确定',
               callback: action => {
                  this.$router.push({ path: "/login" });
                 }
                 });
            } else {
              this.$message.error({ showClose: true, message: result.message, duration: 2000 });
              this.isLoading = false
            }
          }).catch((error) => {
              console.log(error)
            this.$message.error({ showClose: true, message: '请求异常', duration: 2000 });
            this.isLoading = false
          });
        }
        else {
          this.isLoading = false
        }
      })
    },
     sendSms() {
      if (this.isSending) {
        this.$message.warning({
          showClose: true,
          message: "验证码已经发送，请稍后",
          duration: 2000,
        });
        return;
      }
      if (
        this.teamForm.mobile == null ||
        this.teamForm.mobile == "" ||
        !/^[0-9]{11}$/.test(this.teamForm.mobile)
      ) {
        this.$message.error({
          showClose: true,
          message: "手机号码不正确",
          duration: 2000,
        });
        return;
      }
      this.isSending = true;
      let that=this;
      SMSAPI.sendSms({ phoneNumber: this.teamForm.mobile, type: 1 })
        .then((result) => {
          if (result.code == 0) {
            this.$message.success({
              showClose: true,
              message: "验证码已经发送，请注意查收",
              duration: 2000,
            });
            that.timeCounter = 60;
            var intervalTimer = setInterval(() => {
              that.timeCounter--;
              that.smsText = that.timeCounter + "后重新获取";
              if (that.timeCounter <= 0) {
                that.isSending = false;
                that.smsText = "重新获取验证码";
                clearInterval(intervalTimer);
              }
            },1000);
          } else {
            this.$message.error({
              showClose: true,
              message: result.message,
              duration: 2000,
            });
            this.isSending = false;
          }
        })
        .catch((error) => {
          this.$message.error({
            showClose: true,
            message: "请求异常",
            duration: 2000,
          });
          this.isSending = false;
        });
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/views/registerteam.vue